import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.css';
import { connect } from 'react-redux';
import { setBranchId } from '../../../auth/actions';
import PropTypes from 'prop-types';
import TableComp from './Table';
import { Button, Dropdown } from '../../../../common/ui';

const branchOptions = (branchList) =>
  (branchList || []).map((item) => ({ value: item.id, label: item.name }));

const Invoices = ({ setBranchId, auth: { branchList, branchId } }) => {
  const navigate = useNavigate();

  const onClickNewInvoice = () => {
    navigate('/inventory/invoices/new-invoice');
  };

  const handleChangeBranch = (value) => {
    setBranchId(value);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleSection}>
          <h1 className={styles.pageTitle}>Invoices</h1>
          <p className={styles.breadcrumb}>Inventory / Invoices</p>
        </div>
        {branchList && branchList.length > 0 && branchId && (
          <div className={styles.branchSelectWrap}>
            <Dropdown
              label="Branch"
              options={branchOptions(branchList)}
              value={branchId}
              onChange={handleChangeBranch}
              placeholder="Select branch"
            />
          </div>
        )}
      </div>
      <div className={styles.body}>
        <div className={styles.chartMainDiv}>
          <div className={styles.topDiv}>
            <div className={styles.leftDiv}>
              <Button onClick={onClickNewInvoice}>New Invoice</Button>
            </div>
            <div className={styles.rightDiv} />
          </div>
          <div className={styles.chartDiv}>
            <TableComp />
          </div>
        </div>
      </div>
    </div>
  );
};

Invoices.propTypes = {
  setBranchId: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  dashboard: state.dashboard,
  auth: state.authState,
});

export default connect(mapStateToProps, {
  setBranchId,
})(Invoices);
